import { useEffect, useState, createContext } from "react";

import { useApi } from "./useApi";
import { useAuth } from "./useAuth";

import { dateArrayForAllOrders } from "../common/date-functions";

const MemberContext = createContext([{}, () => { }]);

const MemberContextProvider = (props) => {
  const [memberId, setMemberId] = useState("");
  const [memberData, setMemberData] = useState({});
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [customerHref, setCustomerHref] = useState(false);
  const [distributorData, setDistributorData] = useState({});
  const [customerHrefData, setCustomerHrefData] = useState({});
  const [customerOrders, setCustomerOrders] = useState([]);
  const [customerReferrals, setCustomerReferrals] = useState([]);
  const [customerNotes, setCustomerNotes] = useState([]);

  const [apiChainInProgress, setApiChainInProgress] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const { userInfo } = useAuth();
  const { sendRequest } = useApi();

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  //when unicity id is present in the route, make a call to get the customer href
  useEffect(() => {
    const abortController = new AbortController();

    if (memberId) {
      // when unicityId in URL changes, clear all member data
      setCustomerHref(false);
      setMemberData(false);
      setCustomerHrefData(false);
      setCustomerNotes(false);

      setApiChainInProgress(true);

      sendRequest({
        method: "get",
        endpoint: `customers?unicity=${memberId}&expand=customer`,
      })
        .then((res) => {
          setMemberData(res.data.items[0]);

          const promise1 = sendRequest({
            method: "get",
            addPrefix: false,
            endpoint: `${res.data.items[0].href}?expand=profilePicture`,
            abortController,
          }).catch((error) => {
            setErrorMessage(error.message);
          });

          const promise2 = sendRequest({
            method: "get",
            addPrefix: false,
            endpoint: `${res.data.items[0].href
              }/orders?dateCreated=${dateArrayForAllOrders()}`,
            abortController,
          }).catch((error) => {
            setErrorMessage(error.message);
          });

          const promise3 = sendRequest({
            method: "get",
            addPrefix: false,
            endpoint: `${process.env.REACT_APP_OFFICE_API}/${userInfo.unicityId}/members?sponsorUnicityId=${memberId}`,
            abortController,
          }).catch((err) => console.log(err));

          const promise4 = sendRequest({
            method: "get",
            addPrefix: false,
            endpoint: `${process.env.REACT_APP_OFFICE_API}/${userInfo.unicityId}/notes?customerId=${memberId}`,
            abortController,
          }).catch((err) => console.log(err));

          Promise.all([promise1, promise2, promise3, promise4]).then((values) => {
            try {
              setDistributorData(values[0].data);
              setCustomerHrefData(
                values[0] !== undefined ? values[0].data : false
              );
              setCustomerOrders(values[1] !== undefined ? values[1] : false);
              setCustomerReferrals(
                values[2] !== undefined ? values[2].data.items : []
              );
              setCustomerNotes(values[3] !== undefined ? values[3].data.items : [])
              setApiChainInProgress(false);
            } catch {
              resetContext();
            }
          });
        })
        .catch((error) => {
          setErrorMessage(error.message);
        });
    }
    return () => abortController.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberId]);

  // when the drawer closes, clear out error message
  useEffect(() => {
    if (!isDrawerOpen) {
      setErrorMessage("");
    }
  }, [isDrawerOpen]);

  const resetContext = () => {
    setMemberId("");
    setMemberData({});
    setCustomerHrefData({});
    setCustomerOrders([]);
    setCustomerReferrals([]);
    setCustomerNotes([]);
    setApiChainInProgress(true);
  };

  return (
    <MemberContext.Provider
      value={{
        memberData,
        setMemberData,
        customerHref,
        isDrawerOpen,
        setIsDrawerOpen,
        customerHrefData,
        setCustomerHrefData,
        apiChainInProgress,
        customerOrders,
        errorMessage,
        clearErrorMessage,
        customerReferrals,
        customerNotes,
        memberId,
        setMemberId,
        distributorData,
        resetContext
      }}
    >
      {props.children}
    </MemberContext.Provider>
  );
};

export { MemberContext, MemberContextProvider };
